import React from "react"
import Flex from "@/components/Flex"
import { giftcardData } from "./data"
import { m } from "framer-motion"
import Box from "@/components/Box"

const duration = 0.5
const delay = 0.3
const transitionParams = { duration: duration, bounce: 0 }

export const MobileView = () => {
  return (
    <Flex flexDirection={"column"} customCss={{ gap: 2 }} overflow={"hidden"}>
      {giftcardData.map(({ offset, image, key }, index) => {
        const totalRow = index
        return (
          <Flex
            key={key}
            justifyContent={"center"}
            alignItems={"center"}
            customCss={{ gap: 2 }}
            mr={offset === "right" ? "70px" : 0}
            ml={offset === "left" ? "70px" : 0}
          >
            {image.map(({ src, alt }, index) => {
              let translateX = 0
              if (offset === "right") {
                translateX = index === 0 ? -120 : 190
              } else {
                translateX = index === 0 ? -190 : 120
              }

              return (
                <m.div
                  key={alt}
                  initial="partAway"
                  whileInView="collide"
                  viewport={{ once: true }}
                  variants={{
                    partAway: { translateX: translateX },
                    collide: { translateX: 0 },
                  }}
                  transition={{
                    ...transitionParams,
                    delay: totalRow * (duration + delay),
                  }}
                >
                  <Box
                    as={"img"}
                    src={src}
                    width={222}
                    height={143}
                    loading="lazy"
                    alt={alt}
                  />
                </m.div>
              )
            })}
          </Flex>
        )
      })}
    </Flex>
  )
}
